var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.object},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{staticClass:"text-subtitle-2 crumb-item",attrs:{"to":item.href,"disabled":item.disabled,"exact":""}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }